export enum PaymentMethod {
  Cash = "Cash",
  CreditCard = "Credit Card",
  Wires = "Wires",
  Check = "Check",
}
